import * as React from 'react';

const LoggedInCheckoutStateContext = /*#__PURE__*/ React.createContext(null);
LoggedInCheckoutStateContext.displayName = 'LoggedInCheckoutState';
const useLoggedInCheckout = ()=>{
    const context = React.useContext(LoggedInCheckoutStateContext);
    if (context === null) {
        throw new Error('Missing LoggedInCheckoutState provider. You have to wrap the application with the LoggedInCheckoutStateProvider component from the @grandvisionhq/checkout-v2 package.');
    }
    return context;
};

export { LoggedInCheckoutStateContext, useLoggedInCheckout };
//# sourceMappingURL=context.js.map
